import React, { useState, useEffect } from 'react';
import { Alert } from 'react-bootstrap';

const Notification = ({ message, type }) => {
    const [show, setShow] = useState(true);
    useEffect(() => {
        const timer = setTimeout(() => setShow(false), 2000);
        return () => clearTimeout(timer);
    }, []);
    return show ? (
        <Alert variant={type}>{message}</Alert>
    ) : null;
};
export default Notification
